import { useNavigate, useLocation, Link, Outlet, useParams } from "react-router-dom";
import { Container, Navbar, Nav, Button, Row, Col, Card, Spinner, Form, Image, Alert, Offcanvas, Dropdown, ButtonGroup } from "react-bootstrap";
import { CreateQRCode, LinkPreview, RedirectPage, ShareLink } from "./routes/tools/shareLink";
import { DeSoIdentityContext } from "react-deso-protocol";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { handleLogin, UserDropdown } from "./appLoader";
import { createUserAssociation, identity } from "deso-protocol";
import { deso_graphql } from "./utils/graphql";
import { localFees, systemKey } from ".";
import { nodes } from "./utils/helpers";
import { useUserPreferences } from "./contexts/UserPreferences";

import { Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

const definedPaths = [
  "/",
  "/get-started",
  "/popular",
  "/latest",
  "/create",
  "/myshares",
  "/preferences"
];

export const W3lyComponent = () => {
  const { currentUser, alternateUsers, isLoading } = useContext(DeSoIdentityContext);
  const { preferences } = useUserPreferences();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* NAVBAR */}
      <Navbar expand="lg" fixed="top" className="bg-body">
        <Container fluid className="align-items-center">
          <Navbar.Brand as={Link} to="/" className="d-flex flex-row align-items-center">
            <div className="fw-bolder text-info">
              <i className="bi bi-share-fill me-2"></i>
              w3ly.io
            </div>
            <div className="fw-light ps-1">web 3-ly</div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="border-0" />

          {/* Offcanvas Menu */}
          <Navbar.Offcanvas show={show} onHide={handleClose} id="offcanvasNavbar" placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <span className="fw-bolder text-info">
                  <i className="bi bi-share-fill p-0 me-2"></i>w3ly.io
                </span>
                <span className="fw-light ps-1">web 3-ly</span>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="jusitfy-content-evenly align-items-center text-nowrap">
              <Nav className="ms-auto align-items-start align-items-lg-center me-auto text-truncate">
                <Nav.Link as={Link} to="/get-started" active={location.pathname === "/get-started"} onClick={handleClose}>
                  <i className="bi bi-life-preserver me-2"></i>
                  Get started
                </Nav.Link>
                <Nav.Link as={Link} to="/latest" active={location.pathname === "/latest"} onClick={handleClose}>
                  <i className="bi bi-bookmark-star-fill me-2"></i>
                  Latest
                </Nav.Link>
              </Nav>
              <div className="d-lg-none border-muted border-bottom my-4"></div>
              <Nav className="ms-auto align-items-start align-items-lg-center">
                <Nav.Link as={Link} to="/create" active={location.pathname === "/create"} onClick={handleClose}>
                  <i className="bi bi-plus-square-fill me-2"></i>
                  Create...
                </Nav.Link>
                <Nav.Link as={Link} to="/myshares" active={location.pathname === "/myshares"} onClick={handleClose}>
                  <i className="bi bi-share-fill me-2"></i>
                  Shares
                </Nav.Link>
                <Nav.Link as={Link} to="/myqrcodes" active={location.pathname === "/myqrcodes"} onClick={handleClose}>
                  <i className="bi bi-qr-code me-2"></i>
                  QR Codes
                </Nav.Link>
                <Nav.Link as={Link} to="/mylandingpages" active={location.pathname === "/mylandingpages"} onClick={handleClose}>
                  <i className="bi bi-person-badge me-2"></i>
                  Landing Pages
                </Nav.Link>
              </Nav>
              <div className="d-lg-none border-muted border-bottom my-4"></div>
              <Nav className="ms-auto align-items-start align-items-lg-center">
                <Nav.Link as={Link} to="/preferences" active={location.pathname === "/preferences"} onClick={handleClose}>
                  <i className="bi bi-sliders me-2"></i>
                  Preferences
                </Nav.Link>
                <Nav.Link className="">
                  <UserDropdown />
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      {/* MAIN CONTENT WRAPPER */}
      <div className="d-flex flex-column min-vh-100" style={{ marginTop: "56px" }}>
        <Container>
          <Alert variant="warning" className="d-flex align-items-center my-2">
            <i className="bi bi-exclamation-triangle-fill fs-3 me-2"></i>
            <span>This feature is currently in beta testing. Please provide feedback and expect possible changes or bugs.</span>
          </Alert>
        </Container>

        {/* Routed Pages Render Here */}
        <main className="my-auto text-center">
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default W3lyComponent;


export const HomePage = () => (
  <>
    {/* Hero Section */}
    <Container className="text-center pt-5 my-5">
      <div className="d-flex flex-column align-items-center mb-4">
        <h1 className="fw-bolder text-body-emphasis fs-2">
          "web freely"
        </h1>
        <h2 className="fw-bolder text-info fs-3">
          Shorten, Share and Simplify
        </h2>
        <p className="lead">Giving you the tools to share, measure and engage your audience.</p>
        <p>The first shortener powered by blockchain technology, unrivaled social card customisation, QR links, analytics and custom landing pages.</p>
      </div>
    </Container>

    <Container className="mb-5">
      <Row>
        <Col xs={12} md={10} lg={6} className="mx-auto">
          <ShareLink url={`https://beyondsocial.app/posts/7e111e323da9bd75135a84dfd823332d5bb528bfb96d22abefee8529e9e5bf77`} preview={true} />
        </Col>
      </Row>
    </Container>

    <Container className="mb-5">
      <Row>
        <Col xs={12} md={10} lg={6} className="mx-auto">
          <div className="d-flex flex-column align-items-start">
            <p className="fs-5 mb-1">
              <span className="fw-bold">Free</span> sign-in with a DESO wallet
            </p>
            <div className="text-start align-self-center">
              <div className="pb-2 fs-5 fw-light">
                <i className="bi bi-credit-card-2-back-fill me-3"></i>
                No contract or minimum term
              </div>
              <div className="pb-2 fs-5 fw-light">
                <i className="bi bi-infinity text-primary me-3"></i>
                Unlimited use
              </div>
              <div className="pb-2 fs-5 fw-light">
                <i className="bi bi-bar-chart-line-fill text-info me-3"></i>
                Analytics
              </div>
              <div className="pb-2 fs-5 fw-light">
                <i className="bi bi-palette-fill text-success me-3"></i>
                Custom landing pages
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>


    {/* Extra Spacing */}
    <div className="py-5"></div>

    {/* Shorten & Share Section */}
    <div className="bg-body-tertiary bg-opacity-25 bg-gradient py-5 my-5">
      <Container className="text-body px-4 text-center">
        <Row className="align-items-center g-5">
          <Col md={7} lg={8}>
            <h2 className="display-5 fw-bold text-info">Shorten, Share, Simplify</h2>
            <p className="fs-5 mb-4">
              Make web 3.0 addresses short, shareable, and allow users to select their destination front-end.
            </p>
            <Link to="/get-started" className="btn btn-info btn-lg">
              <i className="bi bi-arrow-right-circle-fill me-2"></i>Get Started
            </Link>
          </Col>
          <Col md={5} lg={4}>
            <img
              src="https://images.deso.org/9c9bcde61a801eed291375f0026e74f6f04e7d52d8b044db0edc85bbbf8cc865.webp"
              className="img-fluid rounded-5 w-100"
              alt="Easily shorten and share links"
              loading="lazy"
            />
          </Col>
        </Row>
      </Container>
    </div>

    {/* Extra Spacing */}
    <div className="py-5"></div>

    {/* Social Formatting Section */}
    <div className="bg-body-tertiary bg-opacity-25 bg-gradient py-5 my-5">
      <Container className="text-body px-4 text-center">
        <h2 className="display-6 fw-bold text-info">Clear Previews, User Choice</h2>
        <p className="lead mb-4">
          Create short, easily sharable links from any node, together with rich social card formatting.
        </p>
        <div className="overflow-hidden">
          <img
            src="https://images.deso.org/1dd64e067811599b461b8b7196d034e2b79248e1f9b39c87f75096c6715a1e94.webp"
            className="img-fluid rounded-5 w-100"
            alt="Social sharing preview"
            loading="lazy"
          />
        </div>
        <div className="d-grid gap-2 d-sm-flex justify-content-center mt-4">
          <Link className="btn btn-info btn-lg px-4 mb-2" to="/create"><i className="bi bi-link-45deg me-2"></i>Create Link</Link>
          <Link className="btn btn-primary btn-lg px-4 mb-2" to="/latest"><i className="bi bi-star-fill me-2"></i>See Latest Links</Link>
        </div>
      </Container>
    </div>
  </>
);


export const Preferences = () => {
  const { currentUser, isLoading } = useContext(DeSoIdentityContext);
  const [availableFrontends, setAvailableFrontends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    selected: "",
    redirectAutomatically: false,
  });
  
  useEffect(() => {
      if (!isLoading) {
          fetchUserPreferences();
      }
  }, [isLoading, currentUser]);

  useEffect(() => {
      const activeNodes = Object.keys(nodes)
          .filter((key) => nodes[key].Active && nodes[key].FrontendURL)
          .map((key) => ({
              ...nodes[key],
              id: key,
          }))
          .reverse();
      setAvailableFrontends(activeNodes);
  }, []);
    
  const fetchUserPreferences = async () => {
    setLoading(true);

    if (!currentUser) {
        // If user is not logged in, just load localStorage values
        setFormData({
            selected: localStorage.getItem("preferredFrontend") || "",
            redirectAutomatically: localStorage.getItem("redirectAutomatically") === "true"
        });
        setLoading(false);
        return;
    }

    try {
        const data = await deso_graphql({
            operationName: "UserAssociations",
            variables: {
                first: 1,
                condition: {
                    associationType: "W3LY_SETTINGS",
                    associationValue: "W3LY_SETTINGS",
                    transactorPkid: currentUser.PublicKeyBase58Check,
                }
            },
            query: `
                query UserAssociations($first: Int, $condition: UserAssociationCondition) {
                    userAssociations(first: $first, condition: $condition) {
                        nodes {
                            extraData
                        }
                    }
                }`
        });

        if (data?.data?.userAssociations?.nodes[0]?.extraData) {
            const userPrefs = data.data.userAssociations.nodes[0].extraData;
            setFormData({
                selected: userPrefs.preferredFrontend || "",
                redirectAutomatically: userPrefs.redirectAutomatically === "true"
            });

            // Save preferences locally too
            localStorage.setItem("preferredFrontend", userPrefs.preferredFrontend || "");
            localStorage.setItem("redirectAutomatically", userPrefs.redirectAutomatically.toString());
        }
    } catch (error) {
        console.error("Error fetching preferences:", error);
    } finally {
        setLoading(false);
    }
  };

  const savePreferences = async () => {
      localStorage.setItem("preferredFrontend", formData.selected);
      localStorage.setItem("redirectAutomatically", formData.redirectAutomatically.toString());
      try {
          if (!currentUser) return;

          await createUserAssociation({
              AppPublicKeyBase58Check: systemKey,
              TargetUserPublicKeyBase58Check: currentUser.PublicKeyBase58Check,
              TransactorPublicKeyBase58Check: currentUser.PublicKeyBase58Check,
              AssociationType: "W3LY_SETTINGS",
              AssociationValue: "W3LY_SETTINGS",
              ExtraData: {
                  redirectAutomatically: formData.redirectAutomatically.toString(),
                  preferredFrontend: formData.selected,
              },
              TransactionFees: [localFees(null, 5000)],
          });
          //setSuccess(true);
      } catch (error) {
          console.error("Error saving preferences:", error);
      }
  };


  const handleChange = (key, value) => {
      setFormData(prev => ({ ...prev, [key]: value }));
  };
  
  if (loading) return <Spinner />;

  return (
      <Container className="mt-4">
        <Row>
          <Col xs={12} md={10} lg={6} className="mx-auto">
          <h5>Preferences</h5>
          {success && <Alert variant="success">Preferences updated successfully!</Alert>}
          <Form>
              <Form.Group controlId="frontendSelect">
                  <Form.Label>Select your preferred front-end when following links</Form.Label>
                  <Row className="d-flex justify-content-center text-center px-3">
                    {availableFrontends.map((node) => (
                        <Col
                            xs={4} sm={4} md={3}
                            key={node.id}
                            className={`d-flex flex-column align-items-center justify-content-center rounded-4 py-2 ${formData.selected === node.id ? 'bg-secondary border border-secondary bg-gradient bg-opacity-75 border-primary fw-bold' : 'border-0'}`}
                            style={{ cursor: 'pointer', pointerEvents: 'auto' }}
                            onClick={() => handleChange('selected', node.id)}
                        >
                            <Image 
                                src={`${node.URL ? node.URL : `https://node.deso.org`}/api/v0/get-single-profile-picture/${node.EntryPublicKeyBase58Check}`}
                                alt={node.name}
                                roundedCircle
                                className="img-fluid object-fit-cover px-3"
                            />
                            <div className="mt-2 small">{node.Name}</div>
                        </Col>
                    ))}
                </Row>
              </Form.Group>
              <Form.Group controlId="redirectToggle" className="d-flex flex-row align-items-center justify-content-center mt-2">
                  <Form.Check 
                      type="switch" 
                      label={formData.redirectAutomatically ? "Redirect me automatically" : "Always prompt me"}
                      checked={formData.redirectAutomatically} 
                      onChange={() => handleChange("redirectAutomatically", !formData.redirectAutomatically)}
                  />
              </Form.Group>
              {!currentUser && (
                <Button variant={"primary"} onClick={handleLogin} className="mt-2">Login to save preferences across devices</Button>
              )}
              <Button variant={`success`} className="mt-2" onClick={savePreferences}>
                  Save Preferences
              </Button>
          </Form>
          </Col>
        </Row>
      </Container>
  );
};

export const GetStarted = () => (
  <>
    <Container className="pt-5 my-3">
      <div className="d-flex flex-column align-items-center mb-4">
        <h1 className="fw-bolder text-info fs-2">
          <i className="bi bi-share-fill me-2"></i>w3ly.io
        </h1>
        <p className="fw-light ps-1 fs-4">web 3-ly</p>
      </div>
      <h2 className="fs-5 fw-bold text-info">Shorten, Share, Simplify</h2>
      <p className="lead">w3ly.io (or "web 3-ly") aims to make sharing web 3.0 social links much more flexible and easy to share.</p>
      <p>Rather than urls with long hashed hex values, tied to specific front-ends w3ly allows you to generate short-links that are not tied to a single app or front-end.</p>
      <p>When clicking a link, a user can choose their preferred front-end or app and use that to access the content you share</p>
    </Container>
    <Container className="my-3 py-3">
      <Card>
        <Card.Body className="small">
          <h5>Example</h5>
          <p>Rather than sharing a post from DESO, locked to a specific node:</p>
          <p>https://www.bitclout.com/posts/75f16239b57de0531f9579f3817beb0a67515e4999947f293c112fb0260178e4</p>
          <p>You can share a short link, complete with metadata and allow the user to choose their destination:</p>
          <div className="pb-3">
            <Link to={`https://w3ly.io/HQlCom50`}>
              <Image src={`https://images.deso.org/68c78a5da855ca22b2d7609f0e94af997b3fa5a3957236dab202f8903ee1fcd8.webp`} className="img-fluid" />
            </Link>
          </div>
          <p>Try it: <Link to={`https://w3ly.io/HQlCom50`}>https://w3ly.io/HQlCom50</Link></p>
          <p className="lead fw-bold"><i className="bi bi-heart-fill text-danger me-2"></i>Much friendlier, isn't it?!</p>
        </Card.Body>
      </Card>
    </Container>
    <Container className="my-3 py-3">
      <Link className="btn btn-info btn-lg px-4 m-2" to="/create"><i className="bi bi-link-45deg me-2"></i>Create Link</Link>
      <Link className="btn btn-primary btn-lg px-4 m-2" to="/latest"><i className="bi bi-star-fill me-2"></i>See Latest Links</Link>
    </Container>
  </>
);

export const Create = () => {
  const [type, setType] = useState(null);
  return (
    <>
      <Container>
        <Row className="text-center mb-4">
          <h2>Create new...</h2>
        </Row>
      </Container>
      <Container>
        <ButtonGroup className="text-center mb-4">
          <Button variant='' className={`me-1 hover bg-body p-3 rounded action ${type === "shortlink" ? `fw-bold text-body selected` : `text-muted`}`} onClick={ () => setType("shortlink") }>
            <i className="bi bi-share-fill me-2"></i>
            <span className="text-nowrap">Shortlink</span>
          </Button>
          <Button variant='' className={`me-1 hover bg-body p-3 rounded action ${type === "qrCode" ? `fw-bold text-body selected` : `text-muted`}`} onClick={ () => setType("qrCode") }>
            <i className="bi bi-qr-code me-1"></i>
            <span className="text-nowrap">QR Code</span>
          </Button>
          <Button variant='' className={`hover bg-body p-3 rounded action ${type === "landingPage" ? `fw-bold text-body selected` : `text-muted`}`} disabled={true} onClick={ () => setType("landingPage") }>
            <i className="bi bi-person-badge me-2"></i>
            <span className="text-nowrap">Landing Page</span>
          </Button>
        </ButtonGroup>
      </Container>
      <Container>
        <Row>
          <Col xs={12} md={10} lg={6} className="mx-auto">
            {type === "shortlink" && (<ShareLink />)}
            {type === "qrCode" && (<CreateQRCode />)}
            {type === "landingPage" && (<ShareLink />)}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export const LinksPage = ({ mode = "myshares" }) => {
  const { currentUser, isLoading } = useContext(DeSoIdentityContext);
  const [links, setLinks] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(25);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [associationType, setAssociationType] = useState(
    mode === "myqrcodes" ? "QRCODE" : mode === "mylandingpages" ? "LANDINGPAGE" : "SHORTLINK"
  );

  useEffect(() => {
    if (mode === "myqrcodes") {
      setAssociationType("QRCODE");
    } else if (mode === "mylandingpages") {
      setAssociationType("LANDINGPAGE");
    } else {
      setAssociationType("SHORTLINK");
    }
  }, [mode])

  useEffect(() => {
    setLinks([]);
    setOffset(0);
    setLoad(true);
  }, [currentUser, associationType])

  useEffect(() => {
    if(mode==="popular") {

    } else {
      fetchLinks();
    }
    setLoad(false);
  }, [currentUser, offset, limit, load]);

  const fetchLinks = async () => {
    if (isLoading || (mode === "myshares" && !currentUser) || loading) return; // Prevent fetch if already loading

    setLoading(true);
    try {
      const variables = {
        first: limit,
        offset: offset,
        condition: {
          associationType: associationType,
        },
        orderBy: "BLOCK_HEIGHT_DESC",
      };

      if(mode === "myshares" && currentUser) { variables.condition.transactorPkid = currentUser.PublicKeyBase58Check; }

      const data = await deso_graphql({
        operationName: "UserAssociations",
        variables,
        query: `
          query UserAssociations($first: Int, $offset: Int, $condition: UserAssociationCondition, $orderBy: [UserAssociationsOrderBy!]) {
            userAssociations(first: $first, offset: $offset, condition: $condition, orderBy: $orderBy) {
              nodes {
                associationValue
                associationId
                extraData
                transactor {
                  username
                  extraData
                  publicKey
                }
              }
              totalCount
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
            }
          }`,
      });

      if (data?.data?.userAssociations?.nodes.length > 0) {
        setLinks((prev) => [...prev, ...data.data.userAssociations.nodes]);
        setTotalCount(data.data.userAssociations.totalCount);
        setHasMore(data.data.userAssociations.pageInfo.hasNextPage);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching links:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log(currentUser);

  return (
    <Container>
      <h2>
        {mode === "myshares" && "Your Shortened Links"}
        {mode === "popular" && "Popular Links"}
        {mode === "latest" && "Latest Links"}
        {mode === "myqrcodes" && "Your QR Codes"} {/* Added case for QR Codes */}
        {mode === "mylandingpages" && "Your Landing Pages"} {/* Added case for Landing Pages */}
      </h2>

      {!currentUser && mode === "myshares" && (
        <Row className="my-5">
          <Col>
            <div className="text-muted fs-4">You must be logged in to review links you have created</div>
            <Button variant="primary" onClick={handleLogin}>Log in</Button>
          </Col>
        </Row>
      )}
      
      {links.length === 0 && !loading ? (
        <div className="text-muted fs-4">- No links found -</div>
      ) : (
        <>
          <p>
            Showing {links.length} of {totalCount} results
          </p>
          <Row className="gx-3 gy-3">
            {links.map((link, index) => (
              <Col xs={12} md={6} xl={4} key={index} className="d-flex align-items-stretch position-relative">
                <LinkPreview association={link} currentUser={currentUser} className="flex-grow-1" />
              </Col>
            ))}
          </Row>
        </>
      )}
      
      {loading && <Spinner animation="border" />}

      {hasMore && !loading && (
        <Button onClick={() => setOffset((prev) => prev + limit)} className="mt-3">
          Load More
        </Button>
      )}
    </Container>
  );
};

export const EditLink = () => {
  const { currentUser, isLoading } = useContext(DeSoIdentityContext);
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    fetchLink();
  }, [id, currentUser])

  const fetchLink = async () => {
    if (isLoading || !currentUser || loading) return;
    setLoading(true);
    try {
      const variables = {
        first: 1,
        offset: 0,
        condition: {
          associationType: "SHORTLINK",
          associationId: id,
        },
        orderBy: "BLOCK_HEIGHT_DESC",
      };

      const data = await deso_graphql({
        operationName: "UserAssociations",
        variables,
        query: `
          query UserAssociations($first: Int, $offset: Int, $condition: UserAssociationCondition, $orderBy: [UserAssociationsOrderBy!]) {
            userAssociations(first: $first, offset: $offset, condition: $condition, orderBy: $orderBy) {
              nodes {
                associationValue
                associationId
                extraData
                transactor {
                  username
                  extraData
                  publicKey
                }
              }
              totalCount
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
            }
          }`,
      });

      if (data?.data?.userAssociations?.nodes.length > 0) {
        setLink(data.data.userAssociations.nodes[0]);
      } else {
        setLink(null);
      }
    } catch (error) {
      console.error("Error fetching links:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("Loaded link state:",link)
  return (
    <Container>
      <h2>
        Edit Existing Link
      </h2>
      {loading ? (
        <Row className="my-5 justify-content-center">
          <Spinner />
        </Row>
      ) : (
        <Row className="my-5">
          <Col xs={12} md={10} lg={6} className="mx-auto">
            <ShareLink association={link}  />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export const AnalyseLink = () => {
  const { id } = useParams();
  const { currentUser, isLoading } = useContext(DeSoIdentityContext);
  const [loading, setLoading] = useState(false);
  const [association, setAssociation] = useState(null);
  const [stats, setStats] = useState(null);
  const [refreshRequired, setRefreshRequired] = useState(false);

  useEffect(() => {
    fetchLink();
    setRefreshRequired(false);
  }, [id, currentUser])

  useEffect(() => {
    if(refreshRequired) {
      fetchLink();
      setRefreshRequired(false);
    }
  }, [refreshRequired])

  useEffect(() => {
    if(!isLoading && association && association.transactor.publicKey === currentUser.PublicKeyBase58Check) {
      console.log("Current User is the Association Owner, FETCH STATS...");
      fetchStats();
      setLoading(false);
    }
  }, [association,isLoading,currentUser])

  const fetchStats = async () => {
    if (!association || !currentUser) return;
    try {
      const response = await fetch("https://beyondsocial.app/api.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ endpoint: 'w3ly_analytics', data: { associationId: association.associationValue } }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch stats");
      }
      const data = await response.json();
      console.log("Returned Statistics",data?.data);
      setStats(data?.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const fetchLink = async () => {
    if (isLoading || !currentUser || loading) return;
    setLoading(true);
    try {
      const variables = {
        first: 1,
        offset: 0,
        condition: {
          associationType: "SHORTLINK",
          associationId: id,
        },
        orderBy: "BLOCK_HEIGHT_DESC",
      };

      const data = await deso_graphql({
        operationName: "UserAssociations",
        variables,
        query: `
          query UserAssociations($first: Int, $offset: Int, $condition: UserAssociationCondition, $orderBy: [UserAssociationsOrderBy!]) {
            userAssociations(first: $first, offset: $offset, condition: $condition, orderBy: $orderBy) {
              nodes {
                associationValue
                associationId
                extraData
                transactor {
                  username
                  extraData
                  publicKey
                }
              }
              totalCount
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
            }
          }`,
      });

      if (data?.data?.userAssociations?.nodes.length > 0) {
        setAssociation(data.data.userAssociations.nodes[0]);
      } else {
        setAssociation(null);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching links:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <Container>
        <h2>
          Analyse Link Performance
        </h2>
      </Container>
      {loading ? (
        <Container>
          <Row className="my-5">
            <Col xs={12} md={10} lg={6} className="mx-auto">
              <Spinner />
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          {association && association.transactor.publicKey === currentUser.PublicKeyBase58Check ? (
            <>
              {association.extraData.linkType > 1 || association.extraData.upgraded ? (
                <>
                  {stats && (
                    <AnalyticsDashboard association={association} currentUser={currentUser} setRefreshRequired={setRefreshRequired} stats={stats} />
                  )}
                </>
              ) : (
                <Container>
                  <Row className="my-5">
                    <Col xs={12} md={10} lg={6} className="mx-auto">
                      <LinkPreview association={association} currentUser={currentUser} setRefreshRequired={setRefreshRequired} />
                    </Col>
                  </Row>
                  <Row className="px-3">
                    <p>You need to upgrade this link to analyse statistics or change the metadata.</p>
                    <p>Click the upgrade button on the preview above to do this.</p>
                  </Row> 
                </Container>
              )}
            </>
          ) : (
            <>
              <div>You can only view analytics for your own links</div>
              <div><Link to={`/myshares`}>View your links</Link></div>
            </>
          )}
        </>
      )}
    </>
  );
};

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Tooltip, Legend);

const AnalyticsDashboard = ({ association, currentUser, setRefreshRequired, stats }) => {
  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Analytics Overview</h3>
      </div>
      
      <Row className="d-flex align-items-stretch">
        <Col xs={12} lg={6} className="mx-auto mb-3">
          <LinkPreview association={association} currentUser={currentUser} setRefreshRequired={setRefreshRequired} />
        </Col>
        <Col xs={12} lg={6} className="mx-auto align-items-stretch Asmb-3">
          <StatsCard stats={stats} />
        </Col>        
      </Row>

      <AnalyticsActivity stats={stats} />

      <Row className="py-3 d-flex align-items-stretch">
        <Col xs={12} className="text-start"><h4>User Demographics</h4></Col>
        {renderDetails(stats?.deviceDetails,'demographics')}
      </Row>
      
      <Row className="py-3 d-flex align-items-stretch">
        <Col xs={12} className="text-start"><h4>Device Details</h4></Col>
        {renderDetails(stats?.deviceDetails,'device')}
      </Row>

    </Container>
  );
};


const StatsCard = ({ stats }) => {
  const retrieved = stats?.total?.retrieved || 0;
  const followed = stats?.total?.followed || 0;
  const ctr = retrieved > 0 ? ((followed / retrieved) * 100).toFixed(1) : 0;

  // Chart.js Pie Data
  const labels = ["Followed", "Not Followed"];

  const colors = labels.map((_, index) => standardColors[index % standardColors.length]);

  const chartData = {
    labels,
    datasets: [
      {
        data: [followed, retrieved - followed],
        backgroundColor: colors,
        hoverBackgroundColor: colors.map((color) => darkenColor(color, 0.15)),
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: true,
    aspectRatio: 2/1,
    plugins: {
      legend: {
        position: "bottom", // Moves legend to the bottom
        labels: {
          boxWidth: 12, // Adjusts legend box size
          font: { size: 12 }, // Adjusts legend font size
        },
      },
    },
  };

  return (
    <Row className="h-100">
      {/* Stats Column */}
      <Col xs={12} md={6} className="mb-3">
        <Card className="h-100">
          <Card.Body className="d-flex flex-column justify-content-evenly align-items-start text-nowrap">
            <div className="w-100 d-flex justify-content-between text-muted">
              <span>Info retrieved</span> <span className="fw-bold">{retrieved}</span>
            </div>
            <div className="w-100 d-flex justify-content-between text-success-emphasis">
              <span>Link followed</span> <span className="fw-bold">{followed}</span>
            </div>
            <div className="w-100 d-flex justify-content-between fw-bold">
              <span>Click-through rate</span> <span className="fw-bold">{ctr}%</span>
            </div>
          </Card.Body>
        </Card>
      </Col>

      {/* Chart Column */}
      <Col xs={12} md={6} className="mb-3">
        <Card className="h-100 d-flex align-items-center justify-content-center">
          <Card.Body className="h-100 p-2 position-relative d-flex flex-column justify-content-center">
            <div className="position-relative h-100 w-100 d-flex flex-column justify-content-center align-items-center">
              <Pie data={chartData} options={chartOptions} />
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

const categoryMapping = {
  demographics: ['country', 'time_zone', 'time_zone_offset', 'language'],
  device: ['device_type', 'browser', 'os', 'screen_size', 'connection_speed', 'input_method']
};

const standardColors = [
  "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f", 
  "#edc949", "#af7aa1", "#ff9da7", "#9c755f", "#bab0ab"
];

const darkenColor = (color, amount) => {
  const num = parseInt(color.slice(1), 16);
  let r = (num >> 16) - Math.round(255 * amount);
  let g = ((num >> 8) & 0x00ff) - Math.round(255 * amount);
  let b = (num & 0x0000ff) - Math.round(255 * amount);
  return `rgb(${Math.max(r, 0)}, ${Math.max(g, 0)}, ${Math.max(b, 0)})`;
};

const renderDetails = (details, type) => {
  const filteredCategories = categoryMapping[type] || [];

  return Object.entries(details)
    .filter(([key]) => filteredCategories.includes(key))
    .map(([key, items]) => {
      const sortedItems = items.retrieved.sort((a, b) => b.count - a.count);
      const totalRetrieved = items.retrieved.reduce((acc, item) => acc + item.count, 0);
      let iconprefix = "";
      if (key === "browser") {
        iconprefix = "browser-";
      }

      const labels = sortedItems.map((item) => String(item[Object.keys(item)[0]]));
      const percentages = sortedItems.map((item) =>
        ((item.count / totalRetrieved) * 100).toFixed(0)
      );

      // Generate random colors for each slice
      const colors = labels.map((_, index) => standardColors[index % standardColors.length]);

      const chartData = {
        labels,
        datasets: [
          {
            data: percentages,
            backgroundColor: colors,
            hoverBackgroundColor: colors.map((color) => darkenColor(color, 0.15)),
          },
        ],
      };

      const chartOptions = {
        maintainAspectRatio: false, // Allows custom aspect ratio
        aspectRatio: 4 / 3, // 4:3 ratio
        plugins: {
          legend: {
            display: false,
            position: "bottom", // Moves legend to the bottom
            labels: {
              boxWidth: 12, // Adjusts legend box size
              font: { size: 12 }, // Adjusts legend font size
            },
          },
          tooltip: {
            callbacks: {
              // Use this callback to format the tooltip label as a percentage
              label: function (tooltipItem) {
                const label = tooltipItem.label || ''; // The label for the current segment
                const value = tooltipItem.raw; // The raw value (percentage)
                return `${label}: ${value}%`; // Format as percentage
              },
            },
          },
        },
      };

      return (
        <Col xs={12} md={6} lg={4} className="mb-3 d-flex align-items-stretch" key={key}>
          <Card className="w-100">
            <Card.Header>
              <h6 className="my-0">{formatFieldKey(key, type)}</h6>
            </Card.Header>
            <Card.Body className="d-flex flex-column justify-content-between text-start p-2">
              <div>
                {sortedItems.map((item, index) => {
                  const followedItem = items.followed.find(
                    (f) => f[Object.keys(item)[0]] === item[Object.keys(item)[0]]
                  );
                  const followedCount = followedItem ? followedItem.count : 0;
                  const percentage = totalRetrieved > 0 ? ((item.count / totalRetrieved) * 100).toFixed(2) : 0;
                  let icon = "";
                  let label = String(item[Object.keys(item)[0]]);
                  if (key === "device_type") {
                    if (label === "Desktop") icon = "pc-display";
                    if (label === "Mobile") icon = "phone-fill";
                  } else if(key === "time_zone") {
                    label = getTimeZoneAbbreviation(label);
                  } else if (key==="language") {
                    label = getLanguageName(label);
                  } else if (key === "os") {
                    if(label === "Windows") { icon = "windows"; }
                    if(label === "Android") { icon = "android"; }
                    if(label === "Mac") { icon = "apple"; }
                    if(label === "Linux") { icon = "ubuntu"; }
                  } else if (key === "input_method") {
                    if(label === "Mouse") icon = "mouse-fill";
                    if(label === "Touch") icon = "phone";
                  }

                  if(!icon && !iconprefix) { icon = 'square-fill'; }
                  return (
                    <div className="w-100 d-flex flex-row text-end" key={index}>
                      <div className="col-6 text-start">
                        <i className={`bi bi-${icon ? icon : `${iconprefix}${label.toLowerCase()}`} me-2`} style={{ color: colors[index] }}></i>
                        {label}
                      </div>
                      <div className="col-2">{item.count}</div>
                      <div className="col-2">{followedCount}</div>
                      <div className="col-2">{percentage ? Number(percentage).toFixed(0) : 0}%</div>
                    </div>
                  );
                })}
              </div>
              {/* Simple Pie Chart */}
              <div className="mt-1 justify-content-center" style={{ height: "150px" }}>
                <Pie data={chartData} options={chartOptions} className="mx-auto" />
              </div>
            </Card.Body>
          </Card>
        </Col>
      );
    });
};


const formatFieldKey = (key) => {
  const formattedKey = key.replace(/_/g, ' ');
  let result = formattedKey.replace(/\b\w/, char => char.toUpperCase());

  if (result.length < 4) {
    result = result.toUpperCase();
  }
  return result;
};

const AnalyticsActivity = ({ stats }) => {
  const [grouping, setGrouping] = useState("daily");
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  console.log("Analytics Activity, stats and chart data...",stats, chartData);

  useEffect(() => {
    const tmp = processStats(stats, grouping);

    // Format the chart data for chart.js
    const labels = tmp.map(entry => entry.date); // X-axis: dates
    const retrievedData = tmp.map(entry => entry.retrieved); // Y-axis: retrieved counts
    const followedData = tmp.map(entry => entry.followed); // Y-axis: followed counts

    // Create chart dataset
    const datasets = [
      {
        label: 'Retrieved',
        data: retrievedData,
        borderColor: 'rgba(75, 192, 192, 1)', // Color of the line
        backgroundColor: 'rgba(75, 192, 192, 0.2)', // Background color under the line
        fill: true, // Whether the area under the line is filled
        tension: 0.4 // Line tension for smooth curves
      },
      {
        label: 'Followed',
        data: followedData,
        borderColor: 'rgba(153, 102, 255, 1)', // Color of the line
        backgroundColor: 'rgba(153, 102, 255, 0.2)', // Background color under the line
        fill: true, // Whether the area under the line is filled
        tension: 0.4 // Line tension for smooth curves
      }
    ];

    setChartData({ labels, datasets });
    console.log("ChartData: ", { labels, datasets });
  }, [stats, grouping]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      x: {
        type: 'category', // Use category scale for the X-axis (dates)
        title: {
          display: true,
          text: 'Date/Time'
        },
        offset: chartData?.datasets[0]?.data?.length === 1 ? true : false,
        min: chartData.labels.length === 1 ? 0 : undefined, // Ensure spacing when only one data point exists
        max: chartData.labels.length === 1 ? 1 : undefined, // Ensure spacing when only one data point exists
        ticks: {
          autoSkip: true,
          maxRotation: 90,
          padding: 0,
        }
      },
      y: {
        beginAtZero: true, // Start the Y-axis at zero
        title: {
          display: true,
          text: 'Count'
        }
      }
    }
  };
  

  return (
      <Row className="py-3">
        <Col xs={12}>
          <Card>
            <Card.Header>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <h6>Traffic</h6>
                <Dropdown onSelect={(e) => setGrouping(e)}>
                  <Dropdown.Toggle variant="outline-secondary" id="dropdown-grouping">
                    {grouping}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="hourly">Hourly</Dropdown.Item>
                    <Dropdown.Item eventKey="daily">Daily</Dropdown.Item>
                    <Dropdown.Item eventKey="weekly">Weekly</Dropdown.Item>
                    <Dropdown.Item eventKey="monthly">Monthly</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Card.Header>
            <Card.Body>
              {chartData && (
                <div className="position-relative w-100" style={{ minHeight: '300px' }}>
                  <Line data={chartData} options={chartOptions} />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
  );
};
const processStats = (stats, grouping) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const now = new Date();

  // Function to format dates based on the user's locale and grouping
  const formatDate = (date, grouping) => {
    const options = { timeZone: userTimezone };

    // Determine if locale uses a 12-hour or 24-hour clock
    const is12HourClock = new Intl.DateTimeFormat(undefined, { hour: 'numeric', hour12: true }).resolvedOptions().hour12;

    if (grouping === 'hourly') {
      // Format as short locale (e.g., 4 Apr '25, 9pm), without minutes
      return new Intl.DateTimeFormat(undefined, {
        ...options,
        day: 'numeric',   // Remove leading zero for day
        month: 'short',
        year: '2-digit',
        hour: 'numeric',
        hour12: is12HourClock,  // Only show AM/PM if the locale uses 12-hour clock
      }).format(date);
    }

    if (grouping === 'daily' || grouping === 'weekly') {
      // Format as short locale (e.g., 4 Apr '25)
      return new Intl.DateTimeFormat(undefined, {
        ...options,
        day: 'numeric',   // Remove leading zero for day
        month: 'short',
        year: '2-digit'
      }).format(date);
    }

    if (grouping === 'monthly') {
      // Format as month/year (e.g., April '25)
      return new Intl.DateTimeFormat(undefined, {
        ...options,
        month: 'long',
        year: '2-digit'
      }).format(date);
    }

    return date; // fallback
  };

  // Parse and convert hourly data to user's local timezone
  const hourlyData = stats.hourly.map(entry => {
    const utcDate = new Date(entry.date_hour.replace(' ', 'T') + 'Z'); // Ensure correct UTC parsing
    const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: userTimezone })); // Convert to user's timezone
    return {
      date: localDate,
      retrieved: Number(entry.retrieved_count),
      followed: Number(entry.followed_count)
    };
  });

  let groupedData = {};
  let minDate = new Date(hourlyData[0]?.date);
  let maxDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' })); // Convert now to UTC

  const getKey = (dt) => {
    let localDate = new Date(dt.toLocaleString('en-US', { timeZone: userTimezone }));
    if (grouping === 'hourly') return localDate.toISOString().slice(0, 13) + ':00'; // Hourly key format
    if (grouping === 'daily') return localDate.toISOString().slice(0, 10); // Daily key format
    if (grouping === 'weekly') {
      localDate.setHours(0, 0, 0, 0);
      localDate.setDate(localDate.getDate() - localDate.getDay());
      return localDate.toISOString().slice(0, 10); // Weekly key format
    }
    if (grouping === 'monthly') return localDate.toISOString().slice(0, 7); // Monthly key format
  };

  let currentDate = new Date(minDate);
  while (currentDate <= maxDate) {
    const key = getKey(new Date(currentDate));
    if (!groupedData[key]) {
      groupedData[key] = { retrieved: 0, followed: 0 };
    }
    // Adjusting date increments to account for grouping
    if (grouping === 'hourly') currentDate.setUTCHours(currentDate.getUTCHours() + 1);
    else if (grouping === 'daily') currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    else if (grouping === 'weekly') currentDate.setUTCDate(currentDate.getUTCDate() + 7);
    else if (grouping === 'monthly') currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
  }

  // Ensure the current date is added (for daily, weekly, or monthly groupings)
  const currentKey = getKey(new Date(now)); // Get the key for the current date
  if (!groupedData[currentKey]) {
    groupedData[currentKey] = { retrieved: 0, followed: 0 };
  }

  // Loop through the data and add to groupedData based on the key (hourly/daily/etc.)
  hourlyData.forEach(({ date, retrieved, followed }) => {
    const key = getKey(new Date(date));
    if (groupedData[key]) {
      groupedData[key].retrieved += retrieved;
      groupedData[key].followed += followed;
    }
  });

  // Ensure we return the data in chronological order
  const result = Object.entries(groupedData).map(([key, { retrieved, followed }]) => ({
    date: formatDate(new Date(key), grouping), // Format date based on the grouping
    retrieved,
    followed
  }));

  // Sort by date in chronological order
  return result.sort((a, b) => new Date(a.date) - new Date(b.date));
};


const getLanguageName = (locale) => {
  const languageCode = locale.split("-")[0]; // Extract language part (e.g., "en" from "en-GB")
  const languageNames = new Intl.DisplayNames(["en"], { type: "language" });
  return languageNames.of(languageCode) || locale;
};

const getTimeZoneAbbreviation = (timeZone) => {
  const formatter = new Intl.DateTimeFormat("en", {
    timeZone,
    timeZoneName: "short",
  });
  return formatter.formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value || timeZone;
};